var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 15 13" }, props),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M13.4 5H5l2.5-2.5c.6-.6.6-1.4 0-2s-1.4-.6-2 0l-5 5c-.6.5-.6 1.4 0 2l5 5c.6.6 1.4.6 2 0s.6-1.4 0-2L5 8h8.5c.8 0 1.5-.7 1.5-1.5S14.2 5 13.4 5z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/ArrowLeft.svg